import React from 'react';
import { useTranslations } from 'js/hooks/i18n';

export const withTranslations = WrappedComponent => props => <WrappedComponent {...props} t={useTranslations()} />;
